import { endpoints } from "./endpoints";

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-d.3pwebpp.alzp.tgscloud.net',
    providers: endpoints.providers,
  },
  loaderOnHttp: true,
};
